import { render } from "./LegsView.vue?vue&type=template&id=7b9f4c38"
import script from "./LegsView.vue?vue&type=script&lang=js"
export * from "./LegsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__